module.exports = __webpack_public_path__ + "assets/img/e3e8e24976283f4f3e165ac8d12c52b2.png";